import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DeliveryDetailsModel from "./DeliveryDetailsModel.js";
import Header from "../Header/Header.js";
import Home from "../Home/Home.js";

const DeliveryPage = () => {
    const encodedId = window.location.pathname.split("/").pop();
    const customerId = atob(encodedId);
    const navigate = useNavigate();
    const [deliveryModal, setDeliveryModal] = useState(true);

    const handleClose = () => {
        setDeliveryModal(false);
        navigate("/");
    };

    return (
        <>
            <Home />
            <DeliveryDetailsModel
                customerId={customerId}
                show={deliveryModal}
                onClose={handleClose}
                setdeliveryModal={setDeliveryModal}
            />
        </>
    );
};

export default DeliveryPage;
